import { render } from "./Expandable.vue?vue&type=template&id=31ee5dc8&ts=true"
import script from "./Expandable.vue?vue&type=script&lang=ts"
export * from "./Expandable.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__